import {createAction} from '@reduxjs/toolkit';

const routeChanged = createAction<string>('route/changed');

export {routeChanged};
